<template>
    <!-- 列表区域 -->
    <section class="main">
        <ul class="todo-list">
            <li v-for="(e,i) in list" :key="i" class="todo">
                <div class="view">
                    <span class="index">{{ i + 1 }}.</span> <label>{{ e }}</label>
                    <button @click="del(i)" class="destroy"></button>
                </div>
            </li>
        </ul>
    </section>
</template>

<script>
export default {
    // props: ['list']
    props: {
        list: Array
    },
    methods: {
        del(i) {
            this.$emit('del', i)
        }
    }
}
</script>

<style scoped>

</style>